import { useState } from 'react';
import { useLang } from '../../../LangContext';
import { downloadBlob } from '../../../services/api';

// Liste ve kanban görünümlerinin paylaştığı toplu dosya indirme akışı.
// Dosyalar sunucuda tek ZIP'e paketlenir; tarayıcılar arka arkaya tetiklenen
// çoklu indirmeleri engellediği için her dosyayı ayrı ayrı indirmek güvenilir değil.
export function useSubmissionFilesDownload() {
  const { locale: t } = useLang();
  const [downloadingId, setDownloadingId] = useState(null);

  async function downloadFiles(submissionId) {
    // Paketleme sürerken ikinci bir isteği engelle
    if (downloadingId) return;
    setDownloadingId(submissionId);
    try {
      await downloadBlob(`/api/submissions/${submissionId}/files/zip`, `gonderim-${submissionId}.zip`);
    } catch (exception) {
      // Uç nokta dosyası olmayan gönderim için de 404 döndürür
      window.alert(exception.status === 404 ? t.submissions.noFiles : exception.message);
    } finally {
      setDownloadingId(null);
    }
  }

  return { downloadingId, downloadFiles };
}
